// extracted by mini-css-extract-plugin
export var container = "_sq-0";
export var inputWidth = "_sq-1";